export default __webpack_public_path__ + "static/media/NotoSans-ExtraBold.51555414.ttf";